import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppStatsFoodUpdatePage } from './app-stats-food-update';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
    AppStatsFoodUpdatePage,
  ],
  imports: [
    IonicPageModule.forChild(AppStatsFoodUpdatePage),
    PipesModule,
  ],
})
export class AppStatsFoodUpdatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-stats-food-update/app-stats-food-update.module.ts